import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { legacyInspectionTarget } from './router'

export function LegacyInspectionRedirect(): null {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const target = legacyInspectionTarget(`${location.pathname}${location.search}`)
    if (target !== null) navigate(target, { replace: true })
  }, [location.pathname, location.search, navigate])

  return null
}
